export default __webpack_public_path__ + "static/media/lightroom.424c8312.svg";